module.exports = __webpack_public_path__ + "static/media/modulo-configurador.adbab9e2.svg";